<template>

    <Transition name="slide-fade" appear>  
      <div v-if="show_message" class="z-[100] w-full left-0 bottom-0 fixed text-base">
        <p class="min-w-[6rem] w-fit max-w-[87vw] px-4 min-h-[2.5rem] mx-auto flex justify-center items-center shadow-lg rounded-t bg-green-600 text-white font-medium">
          <svg class="w-5 h-5 fill-white mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
          </svg>
  
          {{ I18N.application.index.copy_text }}
        </p>
      </div>
    </Transition>

    <button @click="copyText" :class="btn_custom_classes" :data-tooltip-target="tooltip_id">
      <svg :class="svgClasses()"  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"></path>
      </svg>
    </button>
    <div :id="tooltip_id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip">
        {{ I18N.application.index.copy }}
    </div>
  
</template>

<script setup>
import { ref, watch } from 'vue'
import { useConstants } from 'composables/useConstants.js'

const props = defineProps(['text', 'btn_custom_classes', 'svg_custom_classes'])

const { I18N } = useConstants()
const show_message = ref(false)
const tooltip_id = ref(
  `url-copied-tooltip${Math.floor(Math.random() * (999999 - 500 + 1)) + 500}-message`
)

watch(show_message, () => {
  setTimeout(() => { show_message.value = false }, 2500)
})

function copyText() {
  navigator.clipboard.writeText(props.text)
  show_message.value = !show_message.value
}

function svgClasses() {
  return props.svg_custom_classes
    ?? 'inline-block cursor-pointer fill-blue-500 hover:fill-blue-600 mr-1 h-4 w-4 dark:fill-gray-400 dark:hover:fill-gray-200'
}
</script>
